// eslint-disable-next-line no-restricted-imports
import { Avatar, Tooltip } from 'antd';
import { sortBy } from 'lodash';
import React from 'react';
import { Avatar as StyledAvatar } from 'components/atoms/avatar';
import { useTranslation } from 'hooks/use-translation';
import { getUserLabel } from 'utils/get-user-label';

const getAvatars = (projectMembers) =>
  projectMembers.map((member) => (
    <StyledAvatar src={member.photoUrl} name={getUserLabel(member)} />
  ));

export const CustomAvatarGroup = ({ projectMembers }) => {
  const sortedMembers = sortBy(projectMembers, ['userId', 'photoUrl']);
  const tooltipContent = useTranslation('view_all_n_members', {
    count: projectMembers.length,
  });
  const totalMembers = useTranslation('more_members_count', {
    count: projectMembers.length - 2,
  });

  return (
    <Avatar.Group>
      {projectMembers.length > 2 ? ( // only max 2 avatars to be visible
        <>
          {getAvatars(sortedMembers.slice(0, 2))}
          <Tooltip title={tooltipContent} placement="top">
            <Avatar style={{ color: '#fff' }}>{totalMembers}</Avatar>
          </Tooltip>
        </>
      ) : (
        getAvatars(sortedMembers)
      )}
    </Avatar.Group>
  );
};
